<template>
  <div class="msg-page">
    <van-nav-bar :title="$t('ui.message.title')" class="nav-bar" fixed placeholder :border="false">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" class="back-icon" alt="back"/>
      </template>
      <template #right>
        <button v-if="unreadCount > 0" class="mark-all-btn" type="button" @click="markAllRead">
          {{ $t('ui.message.mark_all') }}
        </button>
      </template>
    </van-nav-bar>

    <div class="msg-content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('ui.message.empty')" class="msg-empty" />
        <div
          v-for="item in list"
          :key="item.id"
          class="msg-item"
          :class="{ unread: !item.is_read }"
          @click="openItem(item)"
        >
          <div class="msg-item__head">
            <span class="msg-item__title">{{ item.title }}</span>
            <span v-if="!item.is_read" class="msg-item__dot">{{ $t('ui.message.unread') }}</span>
          </div>
          <div class="msg-item__body">{{ item.content }}</div>
          <div class="msg-item__time">{{ item.create_time_text }}</div>
        </div>
      </van-pull-refresh>
    </div>

    <van-popup
      v-model="detailVisible"
      round
      class="site-msg-popup"
      get-container="body"
      :close-on-click-overlay="false"
    >
      <div class="site-msg-card">
        <div class="site-msg-head">
          <div class="site-msg-title">{{ currentMsg.title || $t('ui.message.title') }}</div>
          <button class="site-msg-close" type="button" @click="closeDetail">×</button>
        </div>
        <div class="site-msg-divider"></div>
        <div class="site-msg-content">{{ currentMsg.content }}</div>
        <div class="site-msg-actions">
          <button class="site-msg-button" type="button" @click="closeDetail">{{ $t('ui.message.ok') }}</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      unreadCount: 0,
      detailVisible: false,
      currentMsg: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      this.fetchList().finally(() => {
        this.isLoading = false;
      });
    },
    fetchList() {
      return this.$http({
        method: 'get',
        url: 'user_msg_list'
      }).then((res) => {
        if (res.code === 200) {
          this.list = Array.isArray(res.data) ? res.data : [];
          this.unreadCount = this.list.filter((item) => !Number(item.is_read)).length;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    openItem(item) {
      this.currentMsg = item || {};
      this.detailVisible = true;
    },
    closeDetail() {
      const id = this.currentMsg && this.currentMsg.id;
      const needRead = id && !Number(this.currentMsg.is_read);
      this.detailVisible = false;
      if (needRead) {
        this.markRead(id);
      }
    },
    markRead(id) {
      this.$http({
        method: 'post',
        url: 'user_msg_read',
        data: { id }
      }).then((res) => {
        if (res.code === 200) {
          this.list = this.list.map((item) => (item.id === id ? { ...item, is_read: 1 } : item));
          this.unreadCount = this.list.filter((item) => !Number(item.is_read)).length;
          if (this.$root && typeof this.$root.refreshSiteMsgBadge === 'function') {
            this.$root.refreshSiteMsgBadge();
          }
        }
      });
    },
    markAllRead() {
      this.$http({
        method: 'post',
        url: 'user_msg_read_all'
      }).then((res) => {
        if (res.code === 200) {
          this.list = this.list.map((item) => ({ ...item, is_read: 1 }));
          this.unreadCount = 0;
          this.$toast.success(this.$t('ui.message.marked_all'));
          if (this.$root && typeof this.$root.refreshSiteMsgBadge === 'function') {
            this.$root.refreshSiteMsgBadge();
          }
        } else {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    this.fetchList();
  }
};
</script>

<style lang="less" scoped>
.msg-page {
  min-height: 100vh;
  background: #1f1c1f;
  padding-bottom: 40px;
}

.back-icon {
  width: 20px;
  height: 15px;
}

.mark-all-btn {
  border: none;
  background: transparent;
  color: #f0be88;
  font-size: 24px;
  font-weight: 700;
}

.msg-content {
  padding: 12px 16px 30px;
}

.msg-item {
  margin-bottom: 18px;
  padding: 22px 20px;
  border-radius: 16px;
  border: 1px solid #766350;
  background: linear-gradient(120deg, #212121, #313131);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
}

.msg-item.unread {
  border-color: #f0be88;
}

.msg-item__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.msg-item__title {
  color: #f3c7a2;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.3;
}

.msg-item__dot {
  flex: none;
  padding: 4px 12px;
  border-radius: 999px;
  background: linear-gradient(180deg, #f7dfc5, #eabf93);
  color: #5e3933;
  font-size: 20px;
  font-weight: 800;
}

.msg-item__body {
  margin-top: 14px;
  color: rgba(243, 199, 162, 0.88);
  font-size: 26px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.msg-item__time {
  margin-top: 14px;
  color: rgba(243, 199, 162, 0.55);
  font-size: 22px;
}

.msg-empty {
  padding-top: 80px;
}
</style>
